/**
 * @description i18n en
 * @author wangfupeng
 */

export default {
  tableModule: {
    deleteCol: 'Delete column',
    deleteRow: 'Delete row',
    deleteTable: 'Delete table',
    widthAuto: 'Width auto',
    insertCol: 'Insert column',
    insertRow: 'Insert row',
    insertTable: 'Insert table',
    header: 'Header',
  },
}
